import { connect } from "react-redux";
import SocialEngagementPage from "../components/social-engagement/SocialEngagementPage";

export default connect((state) => ({
  user: state.catalogReducer?.user,
}))(SocialEngagementPage);
